import { FormOption } from 'src/components/form/form-option';
import { PeriodTypeValue } from 'src/pages/reporting/auctions/components/period-type';
import * as pp from 'src/utils/page-params';

export function usePageParams() {
  return pp.usePageParams(
    pp
      .configure()
      .add(pp.start('start'))
      .add(
        pp
          .list('networkPointId')
          .deserialize<FormOption<string>>(JSON.parse)
          .serialize(JSON.stringify)
          .filter({ label: 'Network Point' })
      )
      .add(pp.list('capacityCategoryId').filter({ label: 'Category' }))
      .add(
        pp
          .list('productType')
          .cast<Exclude<PeriodTypeValue, 'WITHINDAY'>>()
          .filter({
            label: 'Product',
          })
      )
      .add(pp.param('runtimeStartFrom').filter({ label: 'Runtime Start' }))
      .add(pp.param('runtimeStartTo').filter({ label: 'Runtime Start' }))
  );
}
export type PageParams = ReturnType<typeof usePageParams>;

export type PageParamsValue = PageParams['value'];
